import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './Loading.css';

const Loading: React.FC = () => {
  const { t } = useI18n();
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>{t.app.common.loading}</p>
    </div>
  );
};

export default Loading;
